import React from 'react'

interface LoadingStateProps {
  variant?: 'spinner' | 'skeleton'
  rows?: number
  message?: string
}

export const Spinner: React.FC<{ size?: 'sm' | 'md' | 'lg'; className?: string }> = ({
  size = 'md',
  className = '',
}) => {
  const sizeMap = { sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-10 w-10' }
  return (
    <span
      className={`inline-block rounded-full border-2 border-gray-200 border-t-indigo-600 animate-spin ${sizeMap[size]} ${className}`}
    />
  )
}

const SkeletonRow: React.FC = () => (
  <div className="flex items-center gap-4 px-4 py-3 border-b border-gray-100 animate-pulse">
    <div className="h-4 bg-gray-200 rounded w-1/4" />
    <div className="h-4 bg-gray-200 rounded w-1/3" />
    <div className="h-4 bg-gray-200 rounded w-1/5" />
    <div className="h-4 bg-gray-200 rounded w-1/6" />
  </div>
)

const LoadingState: React.FC<LoadingStateProps> = ({
  variant = 'spinner',
  rows = 5,
  message = 'Loading...',
}) => {
  if (variant === 'skeleton') {
    return (
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        {Array.from({ length: rows }).map((_, i) => (
          <SkeletonRow key={i} />
        ))}
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3">
      <Spinner size="lg" />
      <p className="text-sm text-gray-400">{message}</p>
    </div>
  )
}

export default LoadingState
